// web/src/components/common/GlobalUIFix.jsx
import React from "react";

export default function GlobalUIFix() {
  return (
    <style data-global-ui-fix>{`
      /* Predictable sizing everywhere */
      *, *::before, *::after { box-sizing: border-box; }

      /* Global app font — match Home page */
      html, body, #root, button, input, select, textarea {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
                     Oxygen, Ubuntu, Cantarell, sans-serif !important;
      }

      /* Modal fields never overflow */
      [role="dialog"] input,
      [role="dialog"] select,
      [role="dialog"] textarea {
        width: 100%;
        max-width: 100%;
        padding: 10px;
        margin: 6px 0 12px;
        border-radius: 10px;
        border: 1px solid #e5e7eb;
        font: inherit;
      }

      /* Recommended sheet width */
      [role="dialog"] > div {
        width: calc(100% - 32px);
        max-width: 480px;
      }

      /* Shared tokens */
      :root{
        --btn-light-bg:#f3f4f6; --btn-light-fg:#0f172a; --btn-light-bd:#e5e7eb;

        --btn-green-a:#22c55e; --btn-green-b:#16a34a;   /* success */
        --btn-blue-a:#3b82f6;  --btn-blue-b:#1d4ed8;    /* primary (Se connecter) */
        --btn-red-a:#ef4444;   --btn-red-b:#dc2626;     /* danger (Déconnexion) */
      }

      /* Base button shape */
      .btn, .btn-light, .btn-success, .btn-primary, .btn-danger{
        display:inline-flex; align-items:center; gap:10px; padding:10px 16px; border-radius:10px;
        font-weight:800; cursor:pointer;
      }

      /* Variants */
      .btn-light{
        background: var(--btn-light-bg) !important;
        color: var(--btn-light-fg) !important;
        border: 1px solid var(--btn-light-bd) !important;
      }
      .btn-success{
        background: linear-gradient(135deg, var(--btn-green-a), var(--btn-green-b)) !important;
        color:#fff !important; border:0 !important;
      }
      .btn-primary{
        background: linear-gradient(135deg, var(--btn-blue-a), var(--btn-blue-b)) !important;
        color:#fff !important; border:0 !important;
      }
      .btn-danger{
        background: linear-gradient(135deg, var(--btn-red-a), var(--btn-red-b)) !important;
        color:#fff !important; border:0 !important;
      }

      /* Fixed auth header placement */
      .header-auth-fixed{
        position: fixed; top: 12px; right: 12px; z-index: 1200;
      }
      .header-auth[data-floating="1"]{
        position: fixed; top: 12px; right: 12px; z-index: 1200;
        max-width: calc(100vw - 24px); /* safety clamp */
      }
      .ha-chip{
        display:inline-flex;align-items:center;gap:10px;
        background:rgba(255,255,255,.95); backdrop-filter:blur(14px);
        border:1px solid rgba(0,0,0,.06); border-radius:12px; padding:8px 10px;
        box-shadow:0 8px 20px rgba(0,0,0,.10);
      }
      .credits-pill{
        font-weight:900;padding:4px 8px;border-radius:999px;
        background:#eef2ff;border:1px solid #e0e7ff;color:#1e3a8a;
      }
      /* Compact buttons inside HeaderAuth (so they don't inflate on ResultsPage) */
      .header-auth .btn{ padding:8px 12px; min-height:auto; font-size:14px; border-radius:10px; }

      /* Two-line layout on mobile (Home + Results) */
      @media (max-width: 640px){
        .home-container .header-auth[data-floating="1"],
        .results-page  .header-auth[data-floating="1"]{
          position: fixed !important;
          top: 12px !important; right: 12px !important; left: auto !important;
          max-width: calc(100vw - 24px) !important;
        }
        .home-container .header-auth .ha-chip,
        .results-page  .header-auth .ha-chip{
          display:flex; flex-wrap:wrap; align-items:center; gap:6px;
        }
        /* line 1 = Bonjour, Name */
        .home-container .header-auth .user-name,
        .results-page  .header-auth .user-name{
          flex:1 1 100%; min-width:0;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        /* line 2 = credits + buttons */
        .home-container .header-auth :where(a,button),
        .results-page  .header-auth :where(a,button){
          white-space: nowrap;
        }
      }

    `}</style>
  );
}
